/**
 * @module geo/payload/facade/services
 */
import { MapOptions } from '../../../types/map';
import { KindService } from '../../../types/services/kind.service';

import { SERVICE_PAYLOAD } from './SERVICE_PAYLOAD';
import { IncomingHttpHeaders } from 'http';

/**
 * Payload will calling internal REST API
 * @since v 2.0.2
 */
export class SERVICE_CALL_REST extends SERVICE_PAYLOAD {
  kindService?: KindService = KindService.CALL_REST;
  parameters:Partial<ServiceCallRestParameters>;
  /**
   * relative url to a geo serice
   */
  

  /**
   * @param options object with properties values
   */
  constructor(options:Partial<SERVICE_CALL_REST>) {
    super(options);
    if(options.parameters){
      this.parameters=new ServiceCallRestParameters(options.parameters);
    }else{
      throw new Error('undefined parameters for call rest service');
    }
 
   
  }
}
export class ServiceCallRestParameters{
   url?: string;
   method?: string;
   sendAsJson: boolean =true;

  /**
   * – Map of strings or objects which will be serialized with the paramSerializer and appended as GET parameters.
   */
   params?: any;

  /**
   * Data to be sent as the request message data.
   */
   data?: any;
   constructor(options:Partial<ServiceCallRestParameters>){
      Object.assign(this,options);
   }
}
